import { UserProfile } from "@shared/types/user";
import React, { createContext, useContext } from "react";
import { useConversationsData } from "../hooks/useConversationsData";
import { Conversation } from "../types";

interface ConversationsContextType {
  conversations: Conversation[];
  loading: boolean;
  error: string | null;
  connectedUsers: string[];
  getOrCreateConversation: (otherUserId: string) => Promise<string | null>;
  userProfiles: Record<string, UserProfile>;
}

const ConversationsContext = createContext<ConversationsContextType | null>(
  null
);

export const ConversationsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const conversationsData = useConversationsData();

  return (
    <ConversationsContext.Provider value={conversationsData}>
      {children}
    </ConversationsContext.Provider>
  );
};

export const useConversations = (): ConversationsContextType => {
  const context = useContext(ConversationsContext);
  if (!context) {
    throw new Error(
      "useConversations must be used within a ConversationsProvider"
    );
  }
  return context;
};
